import ServiceHelper from "components/helpers/service-helper";

class WaitingRoomService {
  constructor() {
    this.waitingRoomUrl = "https://prs-cdp-prod-waitingroom-webapp.azurewebsites.net/api";
    this.company = process.env.GATSBY_MY_PARKS_COMPANY || "TestSSL";

    this.additionalOptions = {
      headers: {
        "X-Company": this.company,
      },
    };
  }

  postWaitingRoomTicket() {
    return ServiceHelper.fetchPost("/waiting-room-tickets", {}, this.additionalOptions, this.waitingRoomUrl);
  }

  getWaitingRoomTicket(key) {
    return ServiceHelper.fetchGet(`/waiting-room-tickets/${key}`, this.additionalOptions, this.waitingRoomUrl);
  }

  deleteWaitingRoomTicket(key) {
    return ServiceHelper.fetchDelete(`/waiting-room-tickets/${key}`, {}, this.additionalOptions, this.waitingRoomUrl);
  }
}

const helper = new WaitingRoomService();
export default helper;
